type ProfileNameFields = {
    firstName?: string;
    lastName?: string;
};

/** Primary golfer display name from firstName + lastName only. */
export function resolvePrimaryGolferName(
    userData: ProfileNameFields | null | undefined
): string {
    return [userData?.firstName, userData?.lastName]
        .map((part) => (part || '').trim())
        .filter(Boolean)
        .join(' ');
}
